<template>
  <footer class="footer">
    <div class="lp-container footer-grid">
      <div class="footer-brand">
        <div class="footer-logo">
          <img src="@/assets/nukli_logo.png" alt="Nukli" class="footer-mark" />
          <span class="footer-name">Nukli</span>
        </div>
        <p class="footer-tagline">{{ $t('footer.tagline') }}</p>
      </div>

      <div class="footer-col">
        <h3 class="footer-heading">{{ $t('footer.product') }}</h3>
        <button v-for="(link, i) in productLinks" :key="i" class="footer-link" @click="nav(link)">
          {{ link.text }}
        </button>
      </div>

      <div class="footer-col">
        <h3 class="footer-heading">{{ $t('footer.legal') }}</h3>
        <router-link v-for="(link, i) in legalLinks" :key="i" :to="link.to" class="footer-link">
          {{ link.text }}
        </router-link>
      </div>
    </div>

    <div class="lp-container footer-bottom">
      <span class="footer-copy">© {{ new Date().getFullYear() }} Nukli. {{ $t('footer.copyright') }}</span>
      <a href="mailto:hola@nukliapp.com" class="footer-mail">hola@nukliapp.com</a>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    productLinks() {
      const l = this.$t('footer.links');
      return [
        { text: l.features, hash: 'features' },
        { text: l.pricing, hash: 'pricing' },
        { text: l.download, route: '/download' },
        { text: l.blog, route: '/blog' },
        { text: l.contact, route: '/contact' },
      ];
    },
    legalLinks() {
      const l = this.$t('footer.links');
      return [
        { text: l.security, to: '/security' },
        { text: l.privacy, to: '/politics/privaci' },
        { text: l.terms, to: '/politics/terms' },
        { text: l.cookies, to: '/politics/cookies' },
      ];
    },
  },
  methods: {
    nav(link) {
      if (link.route) {
        this.$router.push(link.route);
        return;
      }
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          setTimeout(() => document.getElementById(link.hash)?.scrollIntoView({ behavior: 'smooth' }), 300);
        });
      } else {
        document.getElementById(link.hash)?.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>

<style scoped>
.footer {
  background: var(--lp-bg);
  border-top: 1px solid var(--lp-line);
  padding: 72px 0 40px;
}
.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 48px;
  padding-bottom: 48px;
}
.footer-logo { display: flex; align-items: center; gap: 9px; margin-bottom: 16px; }
.footer-mark { width: 24px; height: 24px; object-fit: contain; }
.footer-name {
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  letter-spacing: -0.02em;
  color: var(--lp-ink);
}
.footer-tagline {
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--lp-muted);
  max-width: 320px;
  margin: 0;
}
.footer-col { display: flex; flex-direction: column; align-items: flex-start; }
.footer-heading {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--lp-muted);
  margin: 0 0 16px;
}
.footer-link {
  border: 0;
  background: none;
  cursor: pointer;
  padding: 6px 0;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--lp-ink-2);
  text-decoration: none;
  text-align: left;
  transition: color 0.15s ease;
}
.footer-link:hover { color: var(--lp-accent); }

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 28px;
  border-top: 1px solid var(--lp-line);
}
.footer-copy { font-size: 0.875rem; color: var(--lp-muted); }
.footer-mail { font-size: 0.875rem; color: var(--lp-accent); text-decoration: none; font-weight: 500; }

@media (max-width: 759px) {
  .footer-grid { grid-template-columns: 1fr; gap: 36px; }
}
</style>
